import './App.css';
import Routing from './routing/routing'

function App() {
  return (
    <div className='container'>
      <Routing/>
    </div>
  );
}

export default App;
